<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="first_load">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Time Table </v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-combobox rounded dense required v-model="current_academic_year"
                        :items="ay_std_data.academic_year_list" item-text="Academic Year" label="Academic Year" outlined
                        @change="getDivOff(); getTimeTableVersion()" persistent-hint
                        hint="Please Select Academic Year" />
                </v-col>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-combobox rounded dense required v-model="std" :items="ay_std_data.standard_list"
                        item-text="Standard" label="Standard" outlined @change="getDivOff" persistent-hint
                        hint="Please Select Standard" />
                </v-col>
                <template v-if="division_list != null">
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-combobox rounded dense required v-model="division" :items="division_list" item-text="divname"
                            label="Division" outlined @change="(tt_list = null), (time_table_list = [])" persistent-hint
                            hint="Please Select Division" />
                    </v-col>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete rounded dense required v-model="tt_version" :items="tt_version_list"
                            item-text="name" item-value="id" label="Version" outlined persistent-hint
                            hint="Please Select Version" />
                    </v-col>
                    <v-col sm="2">
                        <br />
                        <v-btn @click="
                            getTT();
                        ignore_clash = false;
                        " class="button mt-0 pt-0" :loading="loader">
                            Proceed
                        </v-btn>
                    </v-col>
                </template>
            </v-row>
        </v-card>

        <v-card v-if="tt_list != null" class="box">
            <v-row dense>
                <v-col cols="12" sm="3" md="3">
                    <v-autocomplete dense v-model="edit_slot_room" :items="all_room_list" item-text="room_number"
                        label="Select Default Room" clearable rounded return-object single-line outlined
                        hint="Select default room for selected division" persistent-hint></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="3" md="3">
                    <v-text-field rounded v-model="web_Link_all" dense clearable return-object outlined
                        label="Enter Webinar Link" hint="Enter Webinar Link" persistent-hint></v-text-field>
                </v-col>
                <v-col sm="2">
                    <v-btn v-if="web_Link_all != null" @click="addWebinarAllTT(web_Link_all)"
                        class="button mt-0 pt-0">Add
                        Link</v-btn>
                </v-col>
            </v-row>
            <v-row class="mt-n4 p-0 m-0 pt-0 mt-0" justify="start" dense>
                <v-col sm="1" md="1" class="p-none m-0 p-0" cols="12" v-if="is_syn_tt_coi">
                    <v-btn color="primary" v-if="is_syn_tt_coi" @click="synCOI"
                        title="Sync Time-Table and Course-Instructor">Sync</v-btn>
                </v-col>
                <v-col sm="1" md="1" class="p-none m-0 p-0" cols="12">
                    <v-checkbox color="#0f2027" v-model="swap" @change="clearSwapData" label="Swap"></v-checkbox>
                </v-col>
                <v-col sm="2" md="2" class="p-none m-0 p-0" cols="12">
                    <v-checkbox color="#0f2027" v-model="ignore_clash" label="Ignore Clashes"></v-checkbox>
                </v-col>
                <v-col sm="2" md="2" class="p-none m-0 p-0" cols="12">
                    <v-checkbox color="#0f2027" v-model="copy_slot" label="Copy Slot"></v-checkbox>
                </v-col>
            </v-row>
            <template v-if="swap">
                <v-row dense class="mt-n10 p-0 m-0 pt-0 mt-0">
                    <v-col sm="1" md="1" class="p-none m-0 p-0" cols="12">
                        <v-checkbox color="#0f2027" class="mr-2" v-model="swap_faculty" label="Faculty"></v-checkbox>
                    </v-col>
                    <v-col sm="1" md="1" class="p-none m-0 p-0" cols="12">
                        <v-checkbox color="#0f2027" class="mr-2" v-model="swap_room" label="Room"></v-checkbox>
                    </v-col>
                    <v-col sm="1" md="1" class="p-none m-0 p-0" cols="12">
                        <v-checkbox color="#0f2027" class="mr-2" v-model="swap_subject"
                            label="Subject/Event"></v-checkbox>
                    </v-col>
                </v-row>
            </template>
            <v-simple-table class="elevation-1 mytable" dense>
                <thead>
                    <tr>
                        <th style="background-color: #ffd699;">
                            {{ std }} : {{ division.divname }}
                        </th>
                        <th class="toolbar" v-for="s in slots" :key="s.id">
                            {{ s.start_time }} - {{ s.end_time }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="tt in tt_list" :key="tt.id">
                        <!-- Day width -->
                        <th width="10%" class="toolbar">
                            <center>{{ tt[0].tt_day }}</center>
                        </th>
                        <td v-for="data in tt" :key="data.id">
                            <v-tooltip color="#403B4A" dark right>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn small v-bind="attrs" v-on="on" width="100%" style="font-size: 11px;"
                                        :id="data.tt_id" class="btn-grad" :color="data.tt_slot_color"
                                        @click="handleSlotClick(data)"
                                        :title="`Subject:${data.tt_course_tip} Faculty:${data.tt_faculty_tip} Room:${data.tt_room} Link:${data.tt_web_link} Event:${data.tt_event_tip}`">
                                        <span v-if="data.tt_course != null">
                                            <v-icon small color="green">mdi-book-open-page-variant</v-icon>
                                            {{ data.tt_course }}
                                        </span>
                                        <span v-if="data.tt_room != null">
                                            <v-icon color="blue" small>mdi-warehouse</v-icon>
                                            {{ data.tt_room }}
                                        </span>
                                        <span v-if="data.tt_event != null">
                                            <v-icon color="green" small>mdi-cricket</v-icon>
                                            {{ data.tt_event }}
                                        </span>
                                        <span v-if="data.tt_faculty != '--'">
                                            <v-icon color="#9808EB" small>mdi-account-tie</v-icon>
                                            {{ data.tt_faculty }}
                                        </span>
                                        <span v-if="data.tt_mul_inst != ''">
                                            <v-icon color="#9808EB" small>mdi-account-plus</v-icon>
                                            <span v-for="i, index in data.tt_mul_inst" :key="index"> {{ index + 1 }}.{{
                                                i
                                                }}</span>
                                        </span>
                                        <span v-if="
                                            data.tt_web_link != null &&
                                            (data.tt_event != null || data.tt_course != null)
                                        ">
                                            <v-icon color="white" small>mdi-link</v-icon>
                                        </span>
                                    </v-btn>
                                </template>
                                <span> Compulsory Time Table </span>
                            </v-tooltip>
                            <span v-if="data.electives.length != 0">
                                <v-tooltip right color="#00DBDE" dark>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" v-on="on" width="100%" @click="getData(data)"
                                            :id="data.tt_id" v-for="(ele, index) in data.electives" :key="index" small
                                            class="pt-2 mt-2 btn1-grad">
                                            <span v-if="ele.ele_crs != null">
                                                <v-icon small color="green">mdi-book-open-page-variant</v-icon>
                                                {{ ele.ele_crs }}
                                            </span>
                                            <span v-if="ele.ele_room != null">
                                                <v-icon color="blue" small>mdi-warehouse</v-icon>
                                                {{ ele.ele_room }}
                                            </span>
                                            <span v-if="ele.ele_event != null">
                                                <v-icon color="green" small>mdi-cricket</v-icon>
                                                {{ ele.ele_event }}
                                            </span>
                                            <span v-if="ele.ele_instructor != '--'">
                                                <v-icon color="#9808EB" small>mdi-account-tie</v-icon>
                                                {{ ele.ele_instructor }}
                                            </span>
                                            <span v-if="ele.tt_ele_mul_inst != ''">
                                                <v-icon color="#9808EB" small>mdi-account-plus</v-icon>
                                                <!-- {{ ele.tt_ele_mul_inst }} -->
                                                <span v-for="i, index in ele.tt_ele_mul_inst" :key="index">
                                                    {{ index + 1 }}.{{ i }}</span>
                                            </span>
                                            <span v-if="
                                                ele.ele_link != '--' &&
                                                (ele.ele_event != null || ele.ele_crs != null)
                                            ">
                                                <v-icon color="white" small>mdi-link</v-icon>
                                            </span>
                                        </v-btn>
                                    </template>
                                    <span> Elective Time Table </span>
                                </v-tooltip>
                            </span>
                            <!-- {{data.tt_room}}::{{data.tt_course}}::{{data.tt_event}}<br>
                {{data.tt_faculty}}-->
                        </td>
                    </tr>
                </tbody>
            </v-simple-table>
            <v-row justify="center">
                <v-col cols="12" sm="12" md="12">
                    <v-toolbar flat dense class="toolbar">
                        <v-toolbar-title>Delete Time Table</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                    <v-autocomplete dense v-model="day" :items="days_list" item-text="day_displayname"
                        label="Select Day" rounded item-value="day_id" outlined hint="Select Day"
                        persistent-hint></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-btn @click="dialog_delete_tt = true" class="button mt-0 pt-0">Delete Time Table</v-btn>
                </v-col>
            </v-row>
            <!-- </v-card-text> -->
        </v-card>
        <!-- {{division}}
    {{tt_list}} -->
        <template>
            <div class="text-center" v-if="sel_slot_data && !isSelectedVersionLocked">
                <v-dialog v-model="dialog" width="700">
                    <v-card>
                        <v-card-title :class="getSlotType == 'Compulsory' ? 'toolbar_2' : 'toolbar_1'"
                            primary-title>Load [{{ getSlotType }}]</v-card-title>
                        <v-card-text>

                            <v-btn class="ml-2 mr-2 mt-2" elevated rounded @click="compulsary_slot = true"
                                :style="{ backgroundColor: compulsary_slot ? '#086613' : '#a0d6a0', color: 'white' }">
                                Compulsory</v-btn>
                            <!-- <v-icon  class="ml-2 mr-2" v-if="getSlotType == 'Compulsory'" color="#086613" >mdi-check-circle-outline</v-icon> -->
                            <v-btn class="mt-2" elevated rounded @click="compulsary_slot = false"
                                :style="{ backgroundColor: compulsary_slot ? '#f7c29e' : '#ea5c09', color: 'white' }">

                                Electives</v-btn>
                            <!-- <v-icon v-if="getSlotType != 'Compulsory'" class="ml-2 mr-2" color="#ea5c09" >mdi-check-circle-outline</v-icon> -->
                            <span v-if="ignore_clash">Clashes are ingnored</span>
                            Clashes are not checked across stream
                            <v-tooltip top color="warning">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon @click="dialog_occ_inst = true" v-bind="attrs" v-on="on"
                                        color="warning">mdi-information</v-icon>
                                </template>
                                <span> Already Assigned Teachers </span>
                            </v-tooltip>

                            <template v-if="compulsary_slot">
                                <v-row>
                                    <v-col sm="5">
                                        <v-autocomplete rounded dense v-model="edit_slot_course"
                                            :items="edit_slot_course_list" item-text="course_name" clearable
                                            return-object single-line outlined hint="Select Course"
                                            persistent-hint></v-autocomplete>
                                    </v-col>
                                    OR
                                    <v-col sm="5">
                                        <v-autocomplete rounded dense v-model="edit_slot_event"
                                            :items="edit_slot_event_list" item-text="tt_event_name" clearable
                                            return-object single-line outlined hint="Select Event"
                                            persistent-hint></v-autocomplete>
                                        <!-- {{edit_slot_event}}||{{edit_slot_event_list}} -->
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-autocomplete rounded dense v-model="edit_slot_faculty"
                                        :items="edit_slot_faculty_list" item-text="faculty_name" clearable return-object
                                        single-line outlined hint="Select Teacher" @change="
                                            checkinst(
                                                edit_slot_faculty.faculty_id,
                                                (type = 'inst'),
                                                (ttyye = 'comp')
                                            )
                                            " persistent-hint></v-autocomplete>
                                </v-row>

                                <!-- @change="
                      checkinst(
                        optional_inst.optional_inst,
                        (type = 'inst'),
                        (ttyye = 'comp')
                      )
                    " -->
                                <v-row dense justify="center" v-if="tt_mul_inst != '' || tt_mul_inst_id != ''">
                                    Already Assigned Optional Teachers:
                                    <span v-for="i, index in tt_mul_inst" :key="index"> {{ index + 1 }}.{{ i }} <v-icon
                                            small @click="delete_opt_inst(tt_mul_inst_id[index])"
                                            color="red">mdi-delete</v-icon></span>
                                </v-row>
                                <v-row>
                                    <v-autocomplete rounded dense v-model="optional_inst"
                                        :items="edit_slot_faculty_list" item-text="faculty_name" clearable multiple
                                        return-object single-line outlined hint="Select Optional Teacher"
                                        persistent-hint
                                        placeholder="If you press save button it will replace already assigned optional teachers"></v-autocomplete>
                                </v-row>
                                <v-row>
                                    <v-autocomplete rounded dense v-model="edit_slot_room" :items="edit_slot_room_list"
                                        item-text="room_number" clearable return-object @change="
                                            checkinst(
                                                edit_slot_room.room_off_id,
                                                (type = 'room'),
                                                (ttyye = 'comp')
                                            )
                                            " single-line outlined hint="Select Room" persistent-hint></v-autocomplete>
                                    <!-- {{edit_slot_room}} -->
                                </v-row>
                                <v-row>
                                    <!-- <v-text-field v-model="web_Link" dense clearable return-object outlined hint="Enter Webinar Link" @change="validateWebinarURL(web_Link)" persistent-hint></v-text-field> -->
                                    <v-text-field rounded v-model="web_Link" dense clearable return-object outlined
                                        hint="Enter Webinar Link" persistent-hint></v-text-field>
                                    <!-- {{edit_slot_room}} -->
                                </v-row>
                            </template>
                            <template v-else>
                                <v-row>Note: Clashes are to be done manually</v-row>
                                <v-row>
                                    <v-col sm="5">
                                        <v-autocomplete rounded dense v-model="elective_data.ele_crs"
                                            :items="edit_slot_course_list" item-value="course_off_id"
                                            item-text="course_name" clearable single-line outlined hint="Select Course"
                                            persistent-hint></v-autocomplete>
                                    </v-col>
                                    OR
                                    <v-col sm="5">
                                        <v-autocomplete rounded dense v-model="elective_data.ele_event"
                                            :items="edit_slot_event_list" item-value="tt_event_id"
                                            item-text="tt_event_name" clearable single-line outlined hint="Select Event"
                                            persistent-hint></v-autocomplete>
                                        <!-- {{edit_slot_event}}||{{edit_slot_event_list}} -->
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-autocomplete rounded dense v-model="elective_data.ele_instructor"
                                        :items="edit_slot_faculty_list" item-value="faculty_id" item-text="faculty_name"
                                        clearable single-line @change="
                                            checkinst(
                                                elective_data.ele_instructor,
                                                (type = 'inst'),
                                                (ttyye = 'ele')
                                            )
                                            " outlined hint="Select Teacher" persistent-hint></v-autocomplete>
                                    <!-- {{edit_slot_faculty}} -->
                                </v-row>

                                <!-- @change="
                      checkinst(
                        elective_data.ele_optional_inst,
                        (type = 'inst'),
                        (ttyye = 'ele')
                      )
                    " -->
                                <v-row>
                                    <v-autocomplete rounded dense v-model="elective_data.ele_optional_inst"
                                        :items="edit_slot_faculty_list" item-value="faculty_id" item-text="faculty_name"
                                        clearable multiple single-line outlined hint="Select Optional Teacher"
                                        persistent-hint></v-autocomplete>
                                    <!-- {{edit_slot_faculty}} -->
                                </v-row>
                                <v-row>
                                    <v-autocomplete rounded dense v-model="elective_data.ele_room"
                                        :items="edit_slot_room_list" item-value="room_off_id" item-text="room_number"
                                        @change="
                                            checkinst(
                                                elective_data.ele_room,
                                                (type = 'room'),
                                                (ttyye = 'ele')
                                            )
                                            " clearable single-line outlined hint="Select Room"
                                        persistent-hint></v-autocomplete>
                                    <!-- {{edit_slot_room}} -->
                                </v-row>
                                <v-row>
                                    <!-- <v-text-field v-model="web_Link" dense clearable return-object outlined hint="Enter Webinar Link" @change="validateWebinarURL(web_Link)" persistent-hint></v-text-field> -->
                                    <v-text-field rounded v-model="elective_data.ele_link" dense clearable outlined
                                        hint="Enter Webinar Link" persistent-hint></v-text-field>
                                    <!-- {{edit_slot_room}} -->
                                </v-row>
                                <!-- {{ elective_data }} -->
                                <v-row>
                                    <v-simple-table class="elevation-1 mytable" dense v-if="electives != ''">
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th>Course</th>
                                                    <th>Event</th>
                                                    <th>Faculty</th>
                                                    <th>Optional Faculty</th>
                                                    <th>Room</th>
                                                    <th>Webinar</th>
                                                    <th>Delete</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="item in electives" :key="item.ele_id">
                                                    <td>{{ item.ele_crs }}</td>
                                                    <td>{{ item.ele_event }}</td>
                                                    <td>{{ item.ele_instructor }}</td>
                                                    <td>
                                                        <span v-if="item.tt_ele_mul_inst != ''">
                                                            <span v-for="i, index in item.tt_ele_mul_inst" :key="index">
                                                                {{ index + 1 }}.{{ i }} <br /> </span>
                                                        </span>
                                                        <span v-else>--</span>
                                                    </td>
                                                    <td>{{ item.ele_room }}</td>
                                                    <td>
                                                        <a v-if="item.ele_link != null" :href="item.ele_link">link</a>
                                                    </td>
                                                    <td>
                                                        <v-btn rounded small icon outlined color="error">
                                                            <v-icon small @click="deleteElectiveData(item.ele_id)"
                                                                color="red">mdi-delete</v-icon>
                                                        </v-btn>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-row>
                            </template>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn v-if="compulsary_slot" color="error" rounded outlined @click="deleteSlot()"><v-icon
                                    color="error">
                                    mdi-delete</v-icon>Delete</v-btn>
                            <v-btn class="button" @click="dialog = false">Cancel</v-btn>
                            <v-btn v-if="compulsary_slot" class="button" @click="saveEidtSlotTT">Save</v-btn>
                            <v-btn v-else class="button" @click="saveCompulsarySlotTT">Add</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>
        <v-card class="box" v-if="slot_type.length != 0 && tt_list != null">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Slots</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <!-- <br />
            <h3>Slots:</h3> -->
            <v-row dense justify="center">
                <span class="pa-2" v-for="st in slot_type" :key="st.id">
                    <v-btn class="mr-2" rounded :color="st.color">{{ st.type }}</v-btn>
                </span>
            </v-row>
        </v-card>
        <v-card class="box" v-if="this.time_table_list != ''">
            <v-data-table :headers="headers" :items="time_table_list">
                <template v-slot:top>
                    <v-toolbar dense flat class="toolbar">
                        <v-toolbar-title>Load Data</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer>
                            <center>Total No. of Hours: {{ total_tt_hr }}</center>
                        </v-spacer>
                    </v-toolbar>
                </template>
            </v-data-table>
        </v-card>

        <v-dialog v-model="dialog1" max-width="1200px">
            <v-card>
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title> Selected Faculty Time Table</v-toolbar-title>
                </v-toolbar>
                <v-container>
                    <faculty-time-table v-if="show_tt == true" :uid="uid"
                        :ay="current_academic_year"></faculty-time-table>
                </v-container>
                <v-row dense justify="center">
                    <v-btn class="button" @click="dialog1 = false">Close</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
        <v-dialog v-model="delete_dialog" max-width="500px">
            <v-card>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-row dense justify="center">
                            <strong>Are sure want delete this time table !!!!</strong>
                        </v-row>
                    </v-card>
                </v-col>
                <v-row dense justify="center">
                    <v-btn class="button" @click="deleteTT()">Yes</v-btn>
                    <v-btn class="button" @click="delete_dialog = false">Close</v-btn>
                </v-row>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_delete_tt" persistent max-width="500px">
            <v-card>
                <v-container>
                    <v-card class="box">
                        <center>
                            <strong>Are you sure you want Delete???</strong>
                        </center>
                        <v-row justify="center">
                            <v-btn class="button" text @click="dialog_delete_tt = false">No</v-btn>
                            <v-btn class="button" text @click="delete_TT()">Yes</v-btn>
                        </v-row>
                    </v-card>
                </v-container>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_delete_tt_opt_inst" persistent max-width="500px">
            <v-card>
                <v-container>
                    <v-card class="box">
                        <center>
                            <strong>Are you sure you want Delete???</strong>
                        </center>
                        <v-row justify="center">
                            <v-btn class="button" text @click="dialog_delete_tt_opt_inst = false">No</v-btn>
                            <v-btn class="button" text @click="deleteOptionalTeacher()">Yes</v-btn>
                        </v-row>
                    </v-card>
                </v-container>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_occ_inst" persistent max-width="1300px">
            <v-card>
                <v-col cols="12" md="12" sm='12'>
                    <v-toolbar flat dense class="toolbar">
                        <v-toolbar-title> Already Assigned Teachers</v-toolbar-title>
                    </v-toolbar>
                    <v-card class="box">
                        <!-- {{ occupide_inst_tt_data }} -->
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                                hide-details></v-text-field>
                        </v-col>
                        <v-simple-table dense class="elevation-1" fixed-header height="500px">
                            <thead>
                                <tr>
                                    <th class="">Sr. No.</th>
                                    <th class="">Teacher</th>
                                    <th class="">Course</th>
                                    <th class="">Event</th>
                                    <th class="">Standard</th>
                                    <th>Division</th>
                                    <th>Elective Time Table data</th>
                                </tr>
                            </thead>
                            <tbody style="overflow-y: scroll;">
                                <tr v-for="(s, index) in filteredItems" :key="index">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ s.tt_faculty }}</td>
                                    <td>{{ s.tt_course }}</td>
                                    <td>{{ s.tt_event_name }}</td>
                                    <td>{{ s.tt_std }}</td>
                                    <td>{{ s.tt_div }}</td>
                                    <td style="width:300px" v-if="s.elective_data">
                                <tr v-for="(ele, index1) in s.elective_data" :key="index1">
                                    Teacher - {{ ele.teacher }} <br>
                                    Course - {{ ele.course }} <br>
                                    Event - {{ ele.event }} <br>
                                    Room - {{ ele.room }} <br>
                                    Standard - {{ ele.std }} <br>
                                    Division - {{ ele.div }}
                                    <hr>
                                </tr>
                                </td>
                                <td v-else> -- </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                        <v-row justify="center">
                            <v-btn class="button" text @click="dialog_occ_inst = false">Close</v-btn>
                        </v-row>
                    </v-card>
                </v-col>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios";
import FacultyTimeTable from "./FacultyTimeTable";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        "faculty-time-table": FacultyTimeTable,
        Breadcrumbs
    },
    data: () => ({
        search: null,
        dialog_occ_inst: false,
        dialog_delete_tt: null,
        dialog_delete_tt_opt_inst: false,
        optional_inst: [],
        copy_slot: false,
        ignore_clash: false,
        compulsary_slot: true,
        first_load: false,
        search: "",
        dialog1: false,
        // extraBreadcrumbItems: [


        // ],
        // breadcrumbClass: "breadcrumb-style1",
        uid: null,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        ay_std_data: null,
        fetch_btn_load: false,
        std: null,
        current_academic_year: null,
        division_list: null,
        division: null,
        tt_version: null,
        tt_version_list: [],
        tt_list: null,
        div_off_id: null,
        all_room_list: null,
        slot_type: [],
        sel_slot_data: null,
        edit_slot_room_list: null,
        edit_slot_room: null,
        edit_slot_faculty_list: null,
        tt_mul_inst: [],
        tt_mul_inst_id: [],
        edit_slot_faculty: null,
        edit_slot_course_list: null,
        edit_slot_course: null,
        edit_slot_event: null,
        edit_slot_event_list: null,
        isvalid: false,
        slots: null,
        is_syn_tt_coi: false,
        //
        swap: false,
        swap_data: [],
        copy_data: [],
        swap_faculty: true,
        swap_room: true,
        swap_subject: true,
        //
        dialog: false,
        web_Link: null,
        show_tt: false,
        //electives
        electives: [],
        occupide_inst_tt_data: [],
        web_Link_all: null,
        loader: false,
        elective_data: {
            ele_id: null,
            ele_link: null,
            ele_crs: null,
            ele_room: null,
            ele_event: null,
            ele_instructor: null,
            ele_optional_inst: [],
        },
        delete_dialog: false,
        time_table_list: [],
        total_tt_hr: null,
        days_list: [],
        day: null,
        overlay: false,
        headers: [
            { text: "Sr No", value: "srno" },
            { text: "Course", value: "course" },
            { text: "No Of Lectures", value: "tt_size" },
        ],
    }),
    computed: {
        getSlotType() {
            if (this.compulsary_slot) return "Compulsory";
            else return "Elective";
        },
        filteredItems() {

            return this.occupide_inst_tt_data.filter((item) => {
                return item.tt_faculty.toLowerCase().indexOf(this.search.toLowerCase()) > -1 || item.tt_course.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
            });
        },
        isSelectedVersionLocked() {
            if (!this.tt_version_list || !this.tt_version) return false;
            const version = this.tt_version_list.find(v => v.id === this.tt_version);
            return version ? version.islocked : false;
        }
    },
    methods: {
        getTimeTableVersion() {
            // alert(this.current_academic_year)
            const data = {
                ay: this.current_academic_year,
            };
            axios
                .post("/timeTable/getTTVersion", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        // this.showSnackbar("success", "Success...");
                        this.tt_version_list = res.data.tt_version_list;
                    } else {
                        this.showSnackbar("error", res.data.snackbar);
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
        },
        addWebinarAllTT(web_Link) {
            const formData = {
                ay: this.current_academic_year,
                std: this.std,
                div_off: this.division.id,
                web_Link: web_Link,
            };

            axios
                .post("/timeTable/addWebLinkToAllCourseTT", formData)
                .then((res) => {
                    if (res.data.status == "YES") {
                        this.showSnackbar("#4caf50", "Webinar Link Save Successfully...");
                    } else {
                        alert(res.data.status_reason);
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.getTT();
                    this.web_Link_all = null;
                });
        },
        checkinst(id, type, ttyye) {
            // alert(ele_instructor)
            // alert(type)
            const formData = {
                tt_id: this.sel_slot_data.tt_id,
                id: id,
                type: type,
                ignore_clash: this.ignore_clash,
            };
            axios
                .post("/timeTable/checkinst", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        if (res.data.inst == "used") {
                            // alert("in if")
                            this.showSnackbar("#b71c1c", "Teacher already used please select another teacher !!...");
                            if (ttyye == "ele") {
                                this.elective_data.ele_instructor = [];
                                this.ele_optional_inst = [];
                                return;
                            } else if (ttyye == "comp") {
                                this.edit_slot_faculty = null;
                                this.optional_inst = [];
                                return;
                            }
                        } else if (res.data.room == "used") {
                            // alert("in else if")
                            this.showSnackbar("#b71c1c", "Room already used please select another room no. !!...");
                            if (ttyye == "ele") {
                                this.elective_data.ele_room = null;
                                return;
                            } else if (ttyye == "comp") {
                                this.edit_slot_room = null;
                                this.optional_inst = [];
                                return;
                            }
                        }
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => { });
        },
        deleteSlot() {
            this.delete_dialog = true;
        },
        deleteTT() {
            //   alert(this.sel_slot_data.tt_id)
            const formData = {
                tt_id: this.sel_slot_data.tt_id,
            };
            axios
                .post("/timeTable/deleteTT", formData)
                .then((res) => {
                    if (res.data.status == "YES") {
                        this.showSnackbar("#4caf50", "Deleted Successfully...");
                        this.getTT();
                    } else {
                        alert(res.data.status_reason);
                    }
                    console.log(this.tt_list);
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.getTT();
                    this.delete_dialog = false;
                    this.dialog = false;
                });
        },
        saveCompulsarySlotTT() {
            if (this.elective_data.ele_room == null || this.elective_data.ele_instructor == null) {
                this.showSnackbar("#b71c1c", "Please select all data.!!...");
                return;
            }
            const formData = {
                tt_id: this.sel_slot_data.tt_id,
                ele_data: this.elective_data,
            };
            axios
                .post("/timeTable/saveCompulsarySlotTT", formData)
                .then((res) => {
                    if (res.data.status == "YES") {
                        this.sel_slot_data.tt_faculty_tip = res.data.faculty_tip;
                        this.sel_slot_data.tt_faculty = res.data.faculty;
                        this.sel_slot_data.tt_course_tip = res.data.course_tip;
                        this.sel_slot_data.tt_course = res.data.course;
                        this.sel_slot_data.tt_room = res.data.room;
                        this.sel_slot_data.tt_event_tip = res.data.event_tip;
                        this.sel_slot_data.tt_event = res.data.event;
                        this.getTT();
                    } else {
                        alert(res.data.status_reason);
                    }
                    console.log(this.tt_list);
                    this.getTT();
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.getTT();
                    this.dialog = false;
                    this.resetElectiveData();
                });
        },
        resetElectiveData() {
            this.elective_data = {
                ele_id: null,
                ele_link: null,
                ele_crs: null,
                ele_room: null,
                ele_event: null,
                ele_instructor: null,
                ele_optional_inst: [],
            };
        },
        deleteElectiveData(ttele_id) {
            //  alert(ttele_id);
            //after delete; electives=res.data.electives
            const formData = {
                ttele_id: ttele_id,
            };
            axios
                .post("/timeTable/deleteElectiveData", formData)
                .then((res) => {
                    if (res.data.status == "YES") {
                        console.log(this.electives);
                        this.electives = res.data.electives;
                        this.getTT();
                    } else {
                        alert(res.data.status_reason);
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.dialog = false;
                });
        },
        getfacultytt(uid) {
            this.uid = uid;
            this.show_tt = true;
            this.dialog1 = true;
        },
        validateWebinarURL(link) {
            //  alert("validateWebinarURL::"+link)
            var myURL = link;
            var mytrimurl = myURL.trim();
            var pattern = new RegExp(
                "^((ft|htt)ps?:\\/\\/)?" + // protocol
                "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name and extension
                "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
                "(\\:\\d+)?" + // port
                "(\\/[-a-z\\d%@_.~+&:]*)*" + // path
                "(\\?[;&a-z\\d%@_.,~+&:=-]*)?" + // query string
                "(\\#[-a-z\\d_]*)?$",
                "i"
            ); // fragment locator');
            if (pattern.test(mytrimurl)) {
                this.isvalid = true;
                return;
            } else {
                alert("Please Enter Valid URL...!");
                this.isvalid = false;
                return;
            }
        },
        synCOI() {
            // alert(this.div_off_id);
            this.is_syn_tt_coi = false;
        },
        clearSwapData() {
            if (this.swap == false) {
                for (var i = 0; i < this.swap_data.length; i++) {
                    document.getElementById(this.swap_data[i]).style.color = "black";
                }
                this.swap_data = [];
            }
        },
        saveEidtSlotTT() {
            // alert(this.web_Link)
            //    if(!this.isvalid){
            //     alert("Please Enter valid Link...");
            //     return
            // }
            var coff_id = null;
            if (this.edit_slot_course != null) coff_id = this.edit_slot_course.course_off_id;

            var faculty_id = null;
            if (this.edit_slot_faculty != null) faculty_id = this.edit_slot_faculty.faculty_id;

            var room_id = null;
            if (this.edit_slot_room != null) room_id = this.edit_slot_room.room_off_id;

            var tt_event_id = null;
            if (this.edit_slot_event != null) tt_event_id = this.edit_slot_event.tt_event_id;

            const formData = {
                tt_id: this.sel_slot_data.tt_id,
                coffid: coff_id,
                facultyid: faculty_id,
                roomid: room_id,
                event_id: tt_event_id,
                web_link: this.web_Link,
                optional_inst: this.optional_inst,
            };
            console.log(formData);
            axios
                .post("/timeTable/saveEidtSlotTT", formData)
                .then((res) => {
                    if (res.data.status == "YES") {
                        this.sel_slot_data.tt_faculty_tip = res.data.faculty_tip;
                        this.sel_slot_data.tt_faculty = res.data.faculty;
                        this.sel_slot_data.tt_course_tip = res.data.course_tip;
                        this.sel_slot_data.tt_course = res.data.course;
                        this.sel_slot_data.tt_room = res.data.room;
                        this.sel_slot_data.tt_event_tip = res.data.event_tip;
                        this.sel_slot_data.tt_event = res.data.event;
                    } else {
                        alert(res.data.status_reason);
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.dialog = false;
                    this.optional_inst = [];
                });
        },
        handleSlotClick(data) {
            if (this.isSelectedVersionLocked) {
                this.showSnackbar("warning", "This timetable version is locked. Editing is disabled.");
                return;
            }
            this.getData(data);
        },

        getData(data) {
            this.sel_slot_data = data;

            if (this.swap == true) {
                if (!this.swap_faculty && !this.swap_room && !this.swap_subject) {
                    alert("Please select one.");
                    return;
                }
                if (this.swap_data.length < 2) {
                    this.swap_data.push(data.tt_id);
                    for (var i = 0; i < this.swap_data.length; i++) document.getElementById(this.swap_data[i]).style.color = "red";
                }
                if (this.swap_data.length == 2) {
                    //code for swap
                    const formData = {
                        swap_faculty: this.swap_faculty,
                        swap_room: this.swap_room,
                        swap_subject: this.swap_subject,
                        swap_data: this.swap_data,
                        ignore_clash: this.ignore_clash,
                    };

                    axios
                        .post("/timeTable/swapSlotData", formData)
                        .then((res) => {
                            if (res.data.status == "YES") {
                            } else {
                                // alert(res.data.status_reason);
                                this.showSnackbar("#32cd32", res.data.status_reason);
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        })
                        .finally(() => {
                            //close loader
                            for (var i = 0; i < this.swap_data.length; i++) {
                                document.getElementById(this.swap_data[i]).style.color = "black";
                            }
                            this.swap_data = [];
                            this.getTT();
                        });
                }
            } else if (this.copy_slot == true) {
                // alert("in if")
                if (this.copy_data.length < 2) {
                    this.copy_data.push(data.tt_id);
                    for (var i = 0; i < this.copy_data.length; i++) document.getElementById(this.copy_data[i]).style.color = "red";
                }
                if (this.copy_data.length == 2) {
                    const formData = {
                        copy_data: this.copy_data,
                        ignore_clash: this.ignore_clash,
                    };

                    axios
                        .post("/timeTable/copySlotData", formData)
                        .then((res) => {
                            if (res.data.status == "YES") {
                                if (this.ignore_clash == false) {
                                    if (res.data.clash_in_elective == true) {
                                        this.showSnackbar("#32cd32", "Clashes found time table copied incompletely");
                                    } else {
                                        this.showSnackbar("#4caf50", "Slot copied  successfully..."); // show snackbar on success
                                    }
                                } else {
                                    this.showSnackbar("#4caf50", "Slot copied  successfully..."); // show snackbar on success
                                }
                            } else {
                                this.showSnackbar("#b71c1c", res.data.status_reason);
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        })
                        .finally(() => {
                            //close loader
                            for (var i = 0; i < this.copy_data.length; i++) {
                                document.getElementById(this.copy_data[i]).style.color = "black";
                            }
                            this.copy_data = [];
                            this.copy_slot = false;
                            this.ignore_clash = false;
                            this.getTT();
                        });
                }
            } else {
                //console.log(this.sel_slot_data)
                const formData = {
                    tt_id: this.sel_slot_data.tt_id,
                    ignore_clash: this.ignore_clash,
                };
                this.resetElectiveData();
                axios
                    .post("/timeTable/editSlotData", formData)
                    .then((res) => {
                        if (res.data.status == "YES") {
                            this.edit_slot_room_list = res.data.rooms;
                            this.edit_slot_faculty_list = res.data.faculties;
                            this.edit_slot_course_list = res.data.courses;
                            this.edit_slot_event_list = res.data.events;
                            // alert(res.data.edit_slot_room.room_off_id)
                            if (res.data.edit_slot_room.room_off_id != null) this.edit_slot_room = res.data.edit_slot_room;
                            this.edit_slot_faculty = res.data.edit_slot_faculty;
                            this.edit_slot_course = res.data.edit_slot_course;
                            this.edit_slot_event = res.data.edit_slot_event;
                            this.web_Link = res.data.web_link;
                            this.tt_mul_inst = res.data.tt_mul_inst;
                            this.tt_mul_inst_id = res.data.tt_mul_inst_id;
                            this.occupide_inst_tt_data = res.data.occupide_inst_tt_data
                            //electives
                            this.electives = res.data.electives;
                        } else {
                            alert(res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.dialog = true;
                    });
            }
        },
        delete_opt_inst(opt_inst_id) {
            this.opt_inst_id = opt_inst_id;
            this.dialog_delete_tt_opt_inst = true;
        },
        async deleteOptionalTeacher() {
            // alert(opt_inst_id)
            const data = {
                opt_inst_id: this.opt_inst_id,
            };
            this.overlay = true;
            try {
                const res = await axios.post("/timeTable/deleteOptionalTeacher", data);
                if (res.data.flag == "YES") {
                    this.showSnackbar("#4caf50", "Deleted successfully");
                    this.overlay = false;
                    this.dialog_delete_tt_opt_inst = false;
                    this.dialog = false;
                    this.getTT();
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
            } catch (err) {
                this.onerror(err);
                this.overlay = false;
            } finally {
                this.overlay = false;
            }
        },
        async delete_TT() {
            const data = {
                ay: this.current_academic_year,
                std: this.std,
                div_off: this.division.id,
                day: this.day,
            };
            this.overlay = true;
            try {
                const res = await axios.post("/timeTable/delete_TT", data);
                if (res.data.flag == "YES") {
                    this.showSnackbar("#4caf50", "Time Table deleted successfully");
                    this.overlay = false;
                    this.dialog_delete_tt = false;
                    this.getTT();
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
            } catch (err) {
                this.onerror(err);
                this.overlay = false;
            } finally {
                this.overlay = false;
            }
        },
        onerror(error) {
            let msg = "";
            if (error.response) {
                msg = "Something went wrong.";
            } else if (error.request) {
                msg = "Please try again.";
            } else {
                msg = "Un-expected error.";
            }
            this.showSnackbar("error", msg);
        },
        getTT() {
            this.loader = true;
            if (this.division.stream == null) {
                this.showSnackbar("#b71c1c", "Please add stream to this divison");
                return;
            }
            if (this.current_academic_year == null || this.std == null || this.division == null) {
                alert("Please select AY, Standard and Division!!!");
                return;
            }
            if (this.tt_version == null) {
                this.showSnackbar("#b71c1c", "Please select Time Table Version");
                this.loader = false;
                return;
            }
            const formData = {
                ay: this.current_academic_year,
                std: this.std,
                div_off: this.division.id,
                tt_version: this.tt_version,
            };
            axios
                .post("/timeTable/getTT", formData)
                .then((res) => {
                    if (res.data.status == "YES") {
                        this.tt_list = res.data.tt_list;
                        this.slots = res.data.slot;
                        this.is_syn_tt_coi = res.data.is_syn_tt_coi;
                        this.div_off_id = res.data.div_off_id;
                        this.all_room_list = res.data.rooms;
                        this.days_list = res.data.days_list;
                        this.edit_slot_room = this.all_room_list[0];
                        this.slot_type = res.data.slot_type;
                        this.time_table_list = res.data.time_table_list;
                        this.total_tt_hr = res.data.total_tt_hr
                        this.loader = false;
                    } else {
                        alert(res.data.status_reason);
                        this.loader = false;
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                    this.loader = false;
                })
                .finally(() => {
                    //close loader
                    this.loader = false;
                });
        },
        getDivOff() {
            this.time_table_list = [];
            this.tt_list = null;
            //api-2
            this.title = null;
            this.description = null;
            this.division_list = null;
            this.division = "";
            this.send_msg_flag = false;

            if (this.std != null && this.current_academic_year != null) {
                const formData = {
                    std: this.std,
                    ay: this.current_academic_year,
                };
                axios
                    .post("/admissionReport/getDivOff", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.division_list = res.data.division_list;
                            if (this.division_list.length == 0) {
                                this.division_list = null;
                                alert("No division found");
                            } else this.division = this.division_list[0];
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                    });
            }
        },
        get_ay_std() {
            //api-1
            axios
                .post("/feesMaster/get_ay_std_ft")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.ay_std_data = res.data.fees_structure_data;
                        this.current_academic_year = res.data.fees_structure_data.current_academic_year;
                        if (this.current_academic_year) {
                            this.getTimeTableVersion();
                        }
                        //this.get_notices();
                    } else {
                        //error
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.first_load = true;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        this.get_ay_std();
    },
};
</script>
<style scoped>
.toolbar_2 {
    background: #086613;
    background: -webkit-linear-gradient(to right, #086613);
    background: linear-gradient(to right, #086613);
    color: white !important;
}

.toolbar_1 {
    background: #ea5c09;
    background: -webkit-linear-gradient(to right, #ea5c09);
    background: linear-gradient(to right, #ea5c09);
    color: white !important;
}



table {
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #cccccc;
}

th {
    border: 1px solid #cccccc;
    padding: 4px;
}

td:nth-child(odd) {
    width: 10em;
    padding: 4px;
    text-align: center;
    border: 1px solid #cccccc;
}

td:nth-child(even) {
    width: 10em;
    padding: 4px;
    text-align: center;
    border: 1px solid #cccccc;
}

.btn-grad {
    /* background-image: linear-gradient(to right, #abbaab 0%, #ffffff  51%, #abbaab  100%) */
}

.btn-grad {
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    color: black;
   
    border-radius: 10px;
    display: block;
}

.btn-grad:hover {
    background-position: right center;
    /* change the direction of the change here */
    color: black;
    text-decoration: none;
}

.btn1-grad {
    background-image: linear-gradient(to right, #085078 0%, #85d8ce 51%, #085078 100%);
}

.btn1-grad {
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    color: white;
    box-shadow: 0 0 20px #eee;
    border-radius: 10px;
    display: block;
}

.btn1-grad:hover {
    background-position: right center;
    /* change the direction of the change here */
    color: #fff;
    text-decoration: none;
}
</style>
